import { Box, styled } from '@mui/joy'
import { myPalette } from '~/shared/lib/theme'

export const Wrapper = styled(Box)`
  background-color: ${myPalette.gray['50']};
  border-radius: 16px;
  padding: 16px;
`
